import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export const ScrollToTop = () => {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    // Sofort nach oben scrollen (nach Route-Wechsel)
    const scrollToTop = () => {
      window.scrollTo(0, 0);
    };
    scrollToTop();
    const t = setTimeout(scrollToTop, 0);
    const t2 = setTimeout(scrollToTop, 50);
    if (hash) {
      const id = hash.replace('#', '');
      const tb = setTimeout(() => {
        const el = document.getElementById(id);
        if (el) el.scrollIntoView({ behavior: 'smooth' });
      }, 150);
      return () => { clearTimeout(t); clearTimeout(t2); clearTimeout(tb); };
    }
    return () => { clearTimeout(t); clearTimeout(t2); };
  }, [pathname, hash]);

  return null;
};
